export const locale = {
    lang: 'pl',
    data: {
        "Reports": "Raporty",
        "How are your users buying over time?": "Jak klienci kupowali w ostatnim czasie?",
        "Date range": "Zakres dat",
        "Selling": "Sprzedaż",
        "Start date": "Od dnia",
        "End date": "Do dnia",
        "Quantity": "Ilość",
        "What are your the best sellers?": "Który z sprzedawców jest najlepszy?",
        "The best sellers": "Najlepsi sprzedawcy",
        "Name": "Nazwa",
        "Products": "Produkty",
        "Vouchers": "Karnety",
        "Total": "Razem",
        "Gross value": "Wartość brutto",
        "What are your top products?": "Jakie produkty najlepiej się sprzedają?",
        "Top products": "Popularne produkty",
        "What are your top vouchers?": "Jakie karnety najlepiej się sprzedają?",
        "Top vouchers": "Popularne karnety",
        "Worker": "Pracownik",
        "Created at": "Data sprzedaży",
        "Selling data": "Dane sprzedaży",
        "Date": "Data",
        "Products value": "Wartość produktów",
        "Selling data by seller and day": "Dane sprzedaży z podziałem na sprzedawcę oraz dzień",
        "PCS": "SZT",
        "Total value": "Razem",
        "Products quantity": "Ilość produktów",
        "Vouchers value": "Wartość karnetów",
        "Vouchers quantity": "Ilość karnetów",
        "Yesterday": "Wczoraj",
        "Today": "Dzisiaj",
        "Last week": "Ostatni tydzień",
        "Last month": "Ostatni miesiąc",
        "Products gross value": "Wartość brutto produktów",
        "Products net value": "Wartość netto produktów",
        "Vouchers gross value": "Wartość brutto karnetów",
        "Vouchers net value": "Wartość netto karnetów",
        "Net value": "Wartość netto",
        "Payment methods summary": "Podsumowanie metod płatności",
        "Payment methods": "Metody płatności",
        "Selling report": "Raport sprzedaży",
        "New customers report": "Nowi klienci",
        "First sale report": "Pierwsza sprzedaż",
        "First sale": "Pierwsza sprzedaż",
        "First online sale": "Pierwsza sprzedaż online",
        "First traditional sale": "Pierwsza sprzedaż tradycyjna",
        "Visitors summary": "Ilość odwiedzających",
        "Visitors per day": "Odwiedzających na dzień",
        "Visits": "Odwiedziny",
        'Error code': 'Kod błędu',
        'Payment method': 'Metoda płatności',
        'Error receipts error': 'Raport błędnych paragonów',
        'Receipt errors report': 'Raport błędnych paragonów',
        'Work time': 'Czas pracy',
        'added': 'Dodany',
        'used': 'Użyty',
        'Service': 'Usługa',
        'Customer': 'Klient',
        'Training Commission': 'Prowizje od treningów',
        'Training Commission Report': 'Raport prowizji od treningów',
        'Training type': 'Typ treningu',
        'Select training type': 'Wybierz typ treningu',
        'All types': 'Wszystkie typy',
        'Fitness Training': 'Trening fitness',
        'Personal Training': 'Trening personalny',
        'EMS Training': 'Trening EMS',
        'Unattended Training': 'Trening bez nadzoru',
        'Service Training': 'Trening usługowy',
        'Training Type': 'Typ treningu',
        'Commission Value': 'Wartość prowizji',
        'Operator': 'Operator',
        'No data available for selected period and type': 'Brak danych dla wybranego okresu i typu',
        'FITNESS_TRAINING': 'Trening fitness',
        'PERSONAL_TRAINING': 'Trening personalny',
        'EMS_TRAINING': 'Trening EMS',
        'UNATTENDED_TRAINING': 'Trening bez nadzoru',
        'SERVICE_TRAINING': 'Trening usługowy',
        'Sale': 'Sprzedaż',
        'SELL': 'Sprzedaż',
        'sell': 'Sprzedaż',
    }
};
